import { HeaderButton } from '@src/containers/Header/HeaderButton';
import {
  Box,
  ButtonVariants,
  EMPTY_ARRAY,
  FormControlSizes,
  HStack,
  Icon,
  IndicatorBadge,
  MixpanelEvent,
  MixpanelEventSource,
  useMixpanel,
} from '@talos/kyoko';
import { useCallback } from 'react';
import type { TradingControlsDialogProps } from './types';

export function TradingControlsDialogButton(props: TradingControlsDialogProps) {
  const { dialog, enabled, dialogInfo, loading, compact } = props;
  const mixpanel = useMixpanel(MixpanelEventSource.TradingControls);

  const handleOpen = useCallback(() => {
    dialog.open();
    mixpanel.track(MixpanelEvent.TradingControlsOpenDialog);
  }, [dialog, mixpanel]);

  if (!enabled) {
    return null;
  }

  const warnings = dialogInfo?.warnings ?? EMPTY_ARRAY;
  const tooltip =
    warnings.length > 0 ? <TradingControlsDialogButtonTooltip showTitle={compact} warnings={warnings} /> : null;

  return (
    <HeaderButton
      borderPlacement="left"
      onClick={handleOpen}
      size={FormControlSizes.Small}
      variant={ButtonVariants.Default}
      data-testid="header-button-trading-controls"
      loading={loading}
      compact={compact}
      tooltip={tooltip}
      dim
    >
      <HStack gap="spacing4">
        {compact ? undefined : 'Trading Controls'}
        <IndicatorBadge
          variant={dialogInfo?.variant}
          children={
            <HStack gap="spacing4" alignItems="flex-start">
              {dialogInfo?.iconName && <Icon icon={dialogInfo.iconName} />}
              {dialogInfo?.counter}
            </HStack>
          }
        />
      </HStack>
    </HeaderButton>
  );
}

function TradingControlsDialogButtonTooltip({ showTitle, warnings }: { showTitle?: boolean; warnings: string[] }) {
  return (
    <div>
      {showTitle && <Box color="colorTextImportant">Trading Controls</Box>}
      {warnings.map((warning, index) => (
        <span key={index}>
          {warning}
          <br />
        </span>
      ))}
    </div>
  );
}
